import { GENERATION_IN_PROGRESS_WARNING } from '@/utils/conversation-reconciliation';
import { Icon } from '@iconify/react';
import { Button, Modal, ModalBody, ModalContent } from '@nextui-org/react';

interface GenerationLeaveModalProps {
  isOpen: boolean;
  onStay: () => void;
  onLeave: () => void;
}

export default function GenerationLeaveModal({
  isOpen,
  onStay,
  onLeave,
}: GenerationLeaveModalProps) {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onStay}
      isDismissable={false}
      hideCloseButton
      classNames={{
        base: 'max-w-[480px] rounded-xl',
      }}
      motionProps={{
        variants: {
          enter: {
            y: 0,
            opacity: 1,
            transition: { duration: 0.25, ease: 'easeOut' },
          },
          exit: {
            y: -12,
            opacity: 0,
            transition: { duration: 0.2, ease: 'easeIn' },
          },
        },
      }}
    >
      <ModalContent data-generation-leave-modal>
        <div className="flex items-start gap-3 bg-gradient-to-r from-amber-50 to-orange-50 px-6 py-5 dark:from-amber-950/40 dark:to-orange-950/30">
          <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-amber-100 dark:bg-amber-900/50">
            <Icon
              icon="mdi:alert-circle-outline"
              className="text-xl text-amber-700 dark:text-amber-300"
              aria-hidden
            />
          </div>
          <div>
            <h2 className="text-lg font-semibold text-[#1a1a1a] dark:text-neutral-100">
              LiFT is still working on your response
            </h2>
            <p className="mt-1 text-sm text-amber-800/80 dark:text-amber-200/80">
              Leaving now will interrupt this response before it finishes.
            </p>
          </div>
        </div>
        <ModalBody className="px-6 py-5">
          <p className="text-[15px] leading-relaxed text-[#4a4a4a] dark:text-neutral-300">
            {GENERATION_IN_PROGRESS_WARNING}
          </p>
          <div className="mt-6 flex gap-2 justify-between border-t mt-4 py-4 pb-0">
            <Button variant="bordered" onPress={onLeave}>
              Leave anyway
            </Button>
            <Button color="primary" onPress={onStay}>
              Stay on page
            </Button>
          </div>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
}
